/**
 * Resolve API base URL with runtime fallback for production.
 *
 * Emergent's standard pattern: frontend served from reallocai.com proxies /api/* to the
 * production backend on the same domain. If the build was baked with a preview backend URL
 * by accident, detecting the production hostname here reroutes requests correctly without
 * requiring a rebuild.
 */
export function resolveBackendBase() {
    const buildBase = process.env.REACT_APP_BACKEND_URL;
    if (typeof window !== 'undefined') {
        const host = window.location.hostname;
        if (host === 'reallocai.com' || host === 'www.reallocai.com') {
            return 'https://reallocai.com';
        }
    }
    return buildBase || '';
}
